import classNames from 'classnames'
import { useRef } from 'react'
import { useEffect, useState } from 'react'

export const OtpFields = ({
  id = 'otp',
  numberOfFields = 4,
  onChange = () => {},
  inputClassName = 'focus:border-primary border-[#E5E5E6]',
  containerClassName = 'space-x-[14.39px]',
  disabled = false,
  clearData = false,
  setOtpError,
  ...rest
}) => {
  const [fildsData, setFilds] = useState([])
  const enterKey = useRef('')

  const setInitialValues = () => {
    let temp = []
    for (let index = 0; index < numberOfFields; index++) {
      temp.push('')
    }
    setFilds([...temp])
  }

  useEffect(() => {
    setInitialValues()
  }, [numberOfFields])

  useEffect(() => {
    if (fildsData?.length != numberOfFields) {
      setInitialValues()
    }
    if (fildsData?.join('')?.trim()?.length <= 0) {
      fildsData.map((item, index) => {
        if (index != 0)
          document.getElementById(`${id + index}`).setAttribute('disabled', 'disabled')
      })
      document?.getElementById(`${id + 0}`)?.removeAttribute('disabled')
    }
    onChange((fildsData || []).join(''))
  }, [fildsData])

  useEffect(() => {
    if (clearData) setInitialValues()
  }, [clearData])

  const disableAllWithout = (id) => {
    for (let index = 0; index < 4; index++) {
      if (index != id)
        document?.getElementById(`${id + index}`)?.setAttribute('disabled', 'disabled')
      else {
        document?.getElementById(id)?.removeAttribute('disabled')
        document?.getElementById(id)?.focus()
      }
    }
  }

  const handleChange = async ({ value, index, isPresent }) => {
    let temp = []
    await setFilds((prv) => {
      if (value === 'Backspace') prv[index] = ''
      else {
        if (!isPresent) {
          prv[index] = value
        } else if (prv[index + 1]?.length <= 1 && index + 1 < numberOfFields) {
          prv[index + 1] = value.split('')[value?.length - 1] || 'g'
        }
      }
      temp = [...prv]
      return [...prv]
    })
    if (numberOfFields != index + 1 && temp?.[index]?.length > 0) {
      document?.getElementById(`${id + (index + 1)}`)?.removeAttribute('disabled')
      document?.getElementById(`${id + (index + 1)}`)?.focus()
      document?.getElementById(`${id + index}`)?.setAttribute('disabled', 'disabled')
    }
  }

  return (
    <div className={classNames('flex', containerClassName)}>
      {fildsData.map((item, index) => {
        return (
          <input
            id={`${id + index}`}
            key={index}
            value={item}
            {...{ ...rest }}
            onKeyUp={(event) => {
              if (item.length < 1 && event.key === 'Backspace' && index != 0) {
                document?.getElementById(`${id + index}`)?.setAttribute('disabled', 'disabled')
                const prevElement = document?.getElementById(`${id + (index - 1)}`)
                prevElement?.removeAttribute('disabled')
                prevElement?.focus()
              }
            }}
            onKeyDown={(e) => (enterKey.current = e.key)}
            disabled={!(fildsData[0].length < 1 && index == 0) && disabled}
            type="tel"
            pattern="^[0-9]"
            autoComplete="off"
            maxLength={'2'}
            onChange={(event) => {
              const value = event?.target?.value?.trim()?.split('') || ''
              if (
                (index != numberOfFields - 1 ||
                  value?.length === 1 ||
                  enterKey.current === 'Backspace') &&
                !value?.includes(' ')
              )
                handleChange({
                  value: value?.[value?.length - 1] || '',
                  index,
                  isPresent: value?.length > 1
                })
            }}
            onPaste={(event) => {
              const digits = event.clipboardData.getData(event.clipboardData.types[0])?.slice(0, 4)
              if (!isNaN(digits)) {
                setOtpError({ isError: false, msg: '' })
                const value = digits?.split('')
                setFilds(value)
                disableAllWithout(`${id + (numberOfFields - 1)}`)
              } else {
                setOtpError({ isError: true, msg: 'Invalid input' })
              }
            }}
            className={classNames(
              'remove  max-h-fit max-w-fit rounded-sm border-[1px] border-solid bg-white p-[0px] text-center font-noto-sans text-base font-normal leading-[19.07px] text-[#333436] outline-none disabled:border-[1px] disabled:border-[#E5E5E6] disabled:bg-[#F2F2F3]',
              inputClassName
            )}
          />
        )
      })}
    </div>
  )
}
